import NAV_CONSTANTS from "../constants/navConstants";
import base from "../utils/stores/base";
import assign from "object-assign";

let navStore = {
    getInitialState() {
        return {
            menuHidden: true,
            hidden: {
                header: false,
                footer: false,
                buyButton: false
            },
            modals: {
                mailingList: false
            }
        };
    },
    handlers: {
        transitionTo: NAV_CONSTANTS.NAV_TRANSITION_TO,
        toggleMenu: NAV_CONSTANTS.NAV_TOGGLE_MENU,
        hide: NAV_CONSTANTS.NAV_HIDE,
        show: NAV_CONSTANTS.NAV_SHOW,
        showModal: NAV_CONSTANTS.NAV_MODAL_SHOW,
        hideModal: NAV_CONSTANTS.NAV_MODAL_HIDE,
        fetchModalData: NAV_CONSTANTS.NAV_MODAL_FETCH
    },
    transitionTo(path) {
        this.app.router.transitionTo(path);
    },
    hide(item) {
        if (!item) { return; }
        this.setState({hidden: assign(this.state.hidden, {[item]: true})});
    },
    show(item) {
        if (!item) { return; }
        this.setState({hidden: assign(this.state.hidden, {[item]: false})});
    },
    menuHidden() {
        return this.state.menuHidden;
    },
    hidden() {
        return this.state.hidden;
    },
    toggleMenu(hidden) {
        this.setState({
            menuHidden: hidden !== undefined ? hidden : !this.state.menuHidden
        });
    },
    hideMailingListModal() {
        this.state.modals.mailingList = false;
        this.hasChanged();
    },
    showMailingListModal() {
        this.state.modals.mailingList = true;
        this.hasChanged();
    },
    mailingListModalVisible() {
        return this.state.modals.mailingList;
    },
    showModal(name, data) {
        this.state.modals[name] = data;
        this.hasChanged();
    },
    hideModal(name) {
        delete this.state.modals[name];
        this.hasChanged();
    },
    fetchModalData(name) {
        return this.state.modals[name];
    }
};

export default base(navStore, NAV_CONSTANTS);



/** WEBPACK FOOTER **
 ** ./app/stores/navStore.js
 **/